
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LoginGoogleButton extends Vue {
    public async handleCallback(credential: string) {
        await this.$store.dispatch('doLoginWithGoogle', {
            idToken: credential,
        })

        this.$router.push('/')
    }

    public beforeMount() {
        const scriptElement = document.querySelector(
            '[src="https://accounts.google.com/gsi/client"]',
        )
        if (!scriptElement && !process.env.JEST_WORKER_ID) {
            const script = document.createElement('script')
            script.src = 'https://accounts.google.com/gsi/client'
            script.async = true
            script.defer = true
            document.body.append(script)
        }
    }

    public mounted() {
        window.onload = () => {
            window.google.accounts.id.initialize({
                client_id:
                    '1091425516257-t65i4l009iotrap8fbem8k1udrqnc77s.apps.googleusercontent.com',
                callback: (response: { credential: string }) =>
                    this.handleCallback(response.credential),
            })
            window.google.accounts.id.renderButton(
                // Ensure the element exist and it is a div to display correcctly
                document.getElementById('google-signin-btn'),
                {
                    theme: 'outline',
                    size: 'large',
                    shape: 'pill',
                    type: 'standard',
                    text: 'continue_with',
                    width: 400,
                    logo_alignment: 'center',
                }, // Customization attributes
            )
        }
    }
}
